import { api } from '@/config/api';
export interface MarketingAppInput {
  name: string; platform: 'android' | 'ios'; androidPackageName?: string; iosBundleId?: string;
  playStoreUrl?: string; appStoreUrl?: string; metaAppId?: string; tiktokAppId?: string;
  googleAppIdentifier?: string; status: 'active' | 'archived';
}
export type AppProvider = 'meta' | 'tiktok' | 'google';
export interface MarketingApp extends MarketingAppInput {
  appUid: string; companyUid: string; identifier: string; createdAt: string; updatedAt: string;
  readiness: Record<AppProvider, { detailsReady: boolean; verified: boolean; missing: string[]; message: string }>;
}
export const marketingAppsService = {
  list: async (params: { search?: string; platform?: string; status?: string; page?: number }, signal?: AbortSignal) =>
    (await api.get<{ items: MarketingApp[]; total: number; page: number; limit: number }>('/slighter_crm/marketing-apps', { params, signal })).data,
  get: async (uid: string, signal?: AbortSignal) => (await api.get<MarketingApp>(`/slighter_crm/marketing-apps/${encodeURIComponent(uid)}`, { signal })).data,
  create: async (input: MarketingAppInput) => (await api.post<MarketingApp>('/slighter_crm/marketing-apps', input)).data,
  update: async (uid: string, input: Partial<MarketingAppInput>) => (await api.patch<MarketingApp>(`/slighter_crm/marketing-apps/${encodeURIComponent(uid)}`, input)).data,
};
